define('responsive-gameday/helpers/PitchListToggle',['require','exports','module','Responsive/util/dom'],function(require,exports,module) {
	var ReDom = require( 'Responsive/util/dom' );

	var DURATION=600;

	function PitchListToggle(controller,el,selector){
		var that=this;
		this.controller=controller;
		this.el=el;
		if(el){
			this.$el=$(el);
			this.el.pitchToggler=this;			
		}
		this.selector=selector||null;
		this.opened={};
		this.pitchesState=function(){
			return that.opened[this.num] ? 'pitches_visible' : '';
		};
		this.className = 'pitches_visible';
	};

	PitchListToggle.prototype.on=function(el,selector){
		this.el=el||this.el;
		this.selector=selector||this.selector;
		this.off(el,selector);
		this.el.pitchToggler=this;
		$(this.el).on('click',this.selector,this.toggle);
	};
	
	PitchListToggle.prototype.off=function(el,selector){
		this.el=el||this.el;
		this.selector=selector||this.selector;

		$(this.el).off('click',this.selector,this.toggle);
	};

	PitchListToggle.prototype.toggle=function (e) {

		var originalEl=(e.delegateTarget||e.currentTarget),
			that=(originalEl).pitchToggler,
			el=this,
			$el = $(this),
			num = $el.attr('data-ab-num'),
			totalHeight = 0,
			holder = $el.siblings('.pitches_holder'),
			indicator = $el.parent(),
			isOpen = indicator.hasClass(that.className);

		if($(e.target).parents('a[href*="#player="]').length){
			return true;
		}
		if(holder.length){
			if (isOpen) {
				holder.css({height : '', zIndex : -1, transitionDuration: DURATION+'ms'});
				that.opened[num]=false;
			} else {
				totalHeight = holder.children('.pitches_holder_bounds').height();
				
				holder.css({ height: totalHeight+'px', zIndex: 0});
				that.opened[num]=true;
			}
			// Make triangle appear 'open'
			indicator.toggleClass(that.className);
		}

		// Using 600ms because this is the transition duration
		setTimeout(function () {
			
			if(that.controller.view){

				if(that.controller.uiDelegate && !isOpen){
					that.controller.setScroll();
				}
				var objectToScroll = that.controller.scroll || that.controller.getView();
				if (el && objectToScroll.offsetHeight < objectToScroll.scrollHeight) {
					if (that.controller.uiDelegate && that.controller.uiDelegate.control) {
						that.controller.uiDelegate.control.scrollToElement(!isOpen ? el : objectToScroll, DURATION);
					} else {
						ReDom.scrollToTop(!isOpen ? el : objectToScroll, true);
					}
				};
				if(that.controller.uiDelegate && isOpen){
					that.controller.setScroll();
				}
			}
		}, DURATION);
		return false;
	};

    return PitchListToggle;
});
